import {
    FETCH_SUMMARY_LOADING,
    FETCH_SUMMARY_SUCCESS,
    FETCH_SUMMARY_FAILED,
  } from "../types";
  
  const initialState = {
    loading: false,
    data: null,
    error: null,
  };
  
  export const statCardsReducer = (state = initialState, action: any) => {
    switch (action.type) {
      case FETCH_SUMMARY_LOADING:
        return { ...state, loading: true };
      case FETCH_SUMMARY_SUCCESS:
        return { ...state, loading: false, data: action.payload };
      case FETCH_SUMMARY_FAILED:
        return { ...state, loading: false, error: action.error };
      default:
        return state;
    }
  };
  export default statCardsReducer;
  